import React, { useState } from "react";
import PopupCard from "./PopupCard";

const SingleCard = ({ card }) => {
  const { author, content, thumbnail, title, date } = card;
  const { name, avatar } = author;
  const { small, large } = thumbnail;
  const [modalIsOpen, setIsOpen] = useState(false);
  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const handlePopup = () => {
    openModal();
  };
  return (
    <div className="card">
      <div className="card-image" onClick={handlePopup}>
        <h3>Learn More</h3>
        <img src={small} alt="small" width="336px" height="150px" />
      </div>
      <div className="card-body">
        <div className="card-title" onClick={handlePopup}>
       <div className="card-color">
       <div className="card-red"></div>
       <div className="card-green"></div>
       </div>
          <h2>{title}</h2>
        </div>
        <div className="card-description">
          <p>{content}</p>
        </div>
        <div className="card-footer">
          <small>{name}</small>
          <small>21th February, 2021</small>
        </div>
      </div>
      <PopupCard card={card} modalIsOpen={modalIsOpen} closeModal={closeModal} />
    </div>
  );
};

export default SingleCard;
